<p class="filter-range-title" [class.is-loading]="isLoading | async">
    <span
        >{{ minValueSelected || minValue | rasCurrency : {} : false : true }}
    </span>
    -
    <span>
        {{ maxValueSelected || maxValue | rasCurrency : {} : false : true }}
        @if (maxValueSelected === configuration.pricingMaxValue) {
            <i>+</i>
        }
    </span>
</p>

<ras-filter-range-slider
    [selectedMax]="maxValueSelected"
    [selectedMin]="minValueSelected"
    [max]="maxValue"
    [min]="minValue"
    [isCurrency]="true"
    [increment]="configuration.pricingIncrement"
    (rangeChange)="onChange($event)"
>
</ras-filter-range-slider>
